import React, { useMemo } from 'react';

import TotalInfoItem from './TotalInfoItem';
import { ReactComponent as TotalOrdersIcon } from 'assets/icons/total-orders-icon.svg';
import { ReactComponent as TotalRedemptionsIcon } from 'assets/icons/total-redemptions-icon.svg';
import { ReactComponent as TotalCustomersIcon } from 'assets/icons/total-customers-icon.svg';
import { useOrderStatisticsQuery } from 'features/dashboard/api/useOrderStatisticsQuery';
import { useTranslation } from 'hooks/useTranslation';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

export const TotalInfo = () => {
  const { t } = useTranslation('dashboard');
  const direction = i18n.dir()

  const classes = useStyles({ direction });
  const { isLoading, data } = useOrderStatisticsQuery();

  const totals = useMemo(() => {
    let totalOrders = 0,
      totalRedemptions = 0,
      totalCustomers = 0;
    if (!isLoading && data) {
      totalOrders = data?.total_orders;
      totalRedemptions = data?.total_redemptions;
      totalCustomers = data?.total_customers;
    }
    return [
      {
        title: t('totalRewardsSent'),
        quantity: totalOrders,
        icon: TotalOrdersIcon,
      },
      {
        title: t('totalRedemptions'),
        quantity: totalRedemptions,
        icon: TotalRedemptionsIcon,
      },
      {
        title: t('totalRecipients'),
        quantity: totalCustomers,
        icon: TotalCustomersIcon,
      },
    ];
  }, [data, isLoading, t]);

  return (
    <div className={classes.totalInfoWrapper}>
      {totals.map((total, index) => (
        <TotalInfoItem
          key={`total-${index}`}
          isLoading={isLoading}
          title={total.title}
          quantity={total.quantity}
          icon={total.icon}
        />
      ))}
    </div>
  );
};
